'use strict';

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index_esm = require('../node_modules/consolidated-events/lib/index.esm.js');

var require$$12 = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index_esm);

module.exports = require$$12;
